"use client";

import dynamic from "next/dynamic";
import { Mountain, Route } from "lucide-react";
import { MountainMapLoading } from "./MountainMapLoading";
import { setShallowSearchParams, useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";

const PlannerApp = dynamic(() => import("@/app/conditions/[slug]/planner/PlannerApp").then(module => module.PlannerApp), {
  ssr: false,
  loading: () => <MountainMapLoading stage="workspace" />,
});

export function MountainMapEntry({ slug, defaultSport = "piste" }: { slug: string; defaultSport?: string }) {
  const active = useShallowSearchParam("tab") === "map";
  const sport = useShallowSearchParam("sport") ?? defaultSport;
  return <section className="py-6 md:py-8"><PlannerApp slug={slug} embedded active={active} sportOverride={sport === "mtb" ? "mtb" : "ski"} /></section>;
}

export function MountainMapInvite() {
  return <button type="button" onClick={() => {
    setShallowSearchParams({ tab: "map" }, { history: "push" });
    document.getElementById("location-sections")?.scrollIntoView({ block: "start" });
    requestAnimationFrame(() => document.getElementById("tab-map")?.focus());
  }} className="mt-6 flex min-h-24 w-full items-center gap-4 rounded-2xl bg-navy px-5 py-5 text-left text-white focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal">
    <Mountain className="shrink-0 text-sky-200" size={32} aria-hidden />
    <span className="flex-1"><span className="block font-heading text-lg font-bold">Explore the mountain</span><span className="mt-1 block text-sm text-white/80">Explore in 2D or 3D, check run scores and plan your route.</span></span>
    <Route size={22} className="shrink-0" aria-hidden />
  </button>;
}
